import React from "react";
import { Form, Input, Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as PasswordHide } from "../../../../../../../assets/icons/password-hidden.svg";
import { ReactComponent as PasswordShow } from "../../../../../../../assets/icons/password-show.svg";
import Validator from "../../../../../../../utils/formValidator";
import { GAForgotPasswordBtnClick } from "../../../../../../../ga/forgotPassword";
import { GAPersonalChangePasswordConfirm } from "../../../../../../../ga/personalCenter";
import "../../../../../../../assets/forgotAndResetPassWordModal.scss";

const ChangePasswordModalRender = ({ form, submitting, handleSubmitChangePassword, handelForgetPassword, handleOnNewPasswordChange }) => {
  const { t } = useTranslation(["personalCenterSetting", "common"]);
  const passWordIconRender = visible => (visible ? <PasswordShow /> : <PasswordHide />);

  return (
    <div className="forget-and-reset-cont p-md-4 p-0">
      <h4 className="fw-bold mb-4">{t("changePassWordModalTitle")}</h4>
      <Form layout="vertical" ref={form} name="forgot-password" validateTrigger="onBlur" className="w-100 mb-3" onFinish={handleSubmitChangePassword}>
        <Form.Item
          name="currentPassword"
          label={t("currentPasswordLabel")}
          rules={[
            {
              required: true,
              formName: "change_password",
              validator: Validator.passwordValidator,
            },
          ]}
        >
          <Input.Password placeholder={t("currentPasswordLabel")} autoComplete="new-password" iconRender={passWordIconRender} />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={t("newPasswordLabel")}
          rules={[
            {
              required: true,
              formName: "change_password",
              validator: Validator.passwordValidator,
            },
          ]}
        >
          <Input.Password
            onChange={handleOnNewPasswordChange}
            placeholder={t("newPasswordLabel")}
            autoComplete="new-password"
            iconRender={passWordIconRender}
          />
        </Form.Item>
        <Form.Item
          name="comfirmPassword"
          label={t("retypePasswordLabel")}
          rules={[
            {
              required: true,
              formName: "change_password",
              validator: async (rule, value) => Validator.passwordSameValidator(rule, value, form.current.getFieldValue("newPassword")),
            },
          ]}
        >
          <Input.Password placeholder={t("retypePasswordLabel")} autoComplete="off" autoComplete="new-password" iconRender={passWordIconRender} />
        </Form.Item>
        <Form.Item className="mb-0">
          <Button
            className="fs-6 fw-bolder submit-btn py-2"
            style={{ minWidth: "50%" }}
            type="primary"
            size="large"
            htmlType="submit"
            loading={submitting}
            onClick={GAPersonalChangePasswordConfirm}
          >
            {t("common:confirm")}
          </Button>
        </Form.Item>
      </Form>
      <a
        className="text-primary"
        onClick={() => {
          handelForgetPassword();
          GAForgotPasswordBtnClick();
        }}
      >
        {t("forgotPassword")}
      </a>
    </div>
  );
};

export default ChangePasswordModalRender;
